import type { Mission } from '../missions.ts'

export const bia: Mission = {
  id: "bia",
  name: "Bureau of Indian Affairs",
  short: "BIA",
  call: "Tribes",
  kind: "subagency",
  parent: "doi",
  url: "https://www.bia.gov/",
  established: 1824,
  palette: {
    primary: "#28166f",
    secondary: "#4b352e",
    accent: "#f8c300",
  },
  colorSource: {
    kind: "seal",
    url: "https://commons.wikimedia.org/wiki/File:Seal_of_the_United_States_Bureau_of_Indian_Affairs.svg",
  },
  motif: "hands",
  mission: {
    text: "Our mission is to enhance the quality of life, promote economic opportunities, and to carry out the federal responsibilities entrusted to us to protect and improve the trust assets of American Indians and Alaska Natives.",
    url: "https://www.bia.gov/bia",
  },
  fact: {
    text: "Established in 1824, the Bureau of Indian Affairs is the oldest agency of the Department of the Interior, responsible for 55 million surface acres held in trust for American Indians, Indian tribes, and Alaska Natives.",
    url: "https://www.bia.gov/about-us",
  },
  seal: {
    file: "public/seals/bia.svg",
    source: "https://commons.wikimedia.org/wiki/File:Seal_of_the_United_States_Bureau_of_Indian_Affairs.svg",
  },
  identifier: {
    about: "https://www.bia.gov/about-us",
    accessibility: "https://www.doi.gov/accessibility",
    foia: "https://www.bia.gov/as-ia/foia",
    noFear: "https://www.doi.gov/pmb/eeo/no-fear-act",
    oig: "https://www.doioig.gov/",
    performance: "https://www.doi.gov/bpp",
    privacy: "https://www.bia.gov/privacy-policy",
  },
  media: {
    photos: [
      {
        file: "/media/bia-wind-river.jpg",
        small: "/media/bia-wind-river-sm.jpg",
        alt: "Sagebrush rangeland in the foreground gives way to badlands and snow-covered mountains under a pale sky.",
        title: "Mountains on the Wind River Reservation, Wyoming",
        creator: "Jennifer Strickland, U.S. Fish and Wildlife Service",
        source: "https://commons.wikimedia.org/wiki/File:Wind_River_Reservation_landscape_(33855166424).jpg",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
